import CBHistoryDetails from './components/CBHistory';

  function App() {
    return (
      <>
        <CBHistoryDetails/>
      </>
    );
  }
  
  export default App;